import { useNavigate } from 'react-router-dom';
import { RiLock2Line, RiArrowLeftLine } from '@remixicon/react';
import { ROUTES } from '@/constants';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center bg-white p-5 rounded-xl">
        <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <RiLock2Line className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Access denied</h1>
        <p className="text-sm text-gray-500 mb-6">
          You don&apos;t have permission to view this page. If you believe this is a
          mistake, please contact your administrator.
        </p>
        <button
          type="button"
          onClick={() => navigate(ROUTES.DASHBOARD.path)}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-full text-sm hover:bg-primary-600 transition-colors"
        >
          <RiArrowLeftLine className="w-4 h-4" />
          Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default Unauthorized;
